/* --------------------------------------------------------
   Importing Legacy Oscar Module
-------------------------------------------------------- */
/*
import oscarModule from "../../vendors/oscar/js/ui.js"; //  ui.js fixed to export
window.oscar = Object.assign(window.oscar || {}, oscarModule);
*/

$(function(){
    var options = {'basketURL': '/shop/basket/'};
    window.oscar.basket.init(options);
})
